import { z } from "zod";
import { userSchema } from "./user";
import { boardSchema } from "./board";
import { accountSchema } from "./account";
import { teamSchema, pendingUserPermissionSchema } from "./team";
import LoadedState from "frontend/state/loadedState";
import { Reflect } from "@workcanvas/reflect/client";
import { MondayUserBoardPermissions } from "frontend/services/monday-api-service";

export const usersSchema = z.map(z.number(), userSchema);

export const appStateSchema = z.object({
  isLoggedIn: z.boolean(),
  user: userSchema.nullable(),
  userState: z.nativeEnum(LoadedState),
  account: accountSchema.nullable(),
  boardsState: z.nativeEnum(LoadedState),
  boards: z.array(boardSchema),
  usersState: z.nativeEnum(LoadedState),
  accountReps: z.instanceof(Reflect).optional(),
  teams: z.array(teamSchema),
  teamsState: z.nativeEnum(LoadedState),
  pendingUsersPermissions: z.array(pendingUserPermissionSchema).default([]),
  mondayBoardAccessPermission: z.nativeEnum(MondayUserBoardPermissions).default(MondayUserBoardPermissions.view),
});

export type AppState = z.infer<typeof appStateSchema>;
export type Users = z.infer<typeof usersSchema>;
